import { Box, Text } from "grommet";
import * as React from "react";

const TeamMemberRole = ({ role }) => {
    let color = "brand";
    switch (role) {
        case "Member":
            color = "default";
            break;
        case "Captain":
            color = "accent-3";
            break;
        case "League Master":
            color = "accent-2";
            break;
    }
    return (
        <Text size="small" color={color}>
            {role}
        </Text>
    );
};

export default TeamMemberRole;
